import React, { useState, useLayoutEffect } from 'react';
import clsx from 'clsx';
import BackgroundImage from 'gatsby-background-image';
import { convertToBgImage } from 'gbimage-bridge';

import Container from '@common/Container';
import Row from '@common/Row';
import Img from '@common/Image';
import Button from '@common/Button';
import RichText from '@common/RichText';
import SmallTitle from '@common/SmallTitle';

const BackgroundImages = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    listClass,
    imagePosition,
    imagePositionTop,
    imageWidth,
    imageMaxHeight,
    buttons,
    images
  } = data;
  const [sources, setSources] = useState(null);
  const [imageList, setImgList] = useState(null);
  useLayoutEffect(() => {
    // Filter background images
    const bgImage = convertToBgImage(images?.find(x => x.title === 'Background').gatsbyImageData);
    const mobileBgImg = convertToBgImage(images?.find(x => x.title === 'Mobile Background').gatsbyImageData);
    const sources = [
      mobileBgImg?.fluid,
      {
        ...bgImage?.fluid,
        media: `(min-width: 601px)`
      }
    ];
    setSources(sources);

    // Filter out background images
    const newImages = images?.filter(x => x.title !== 'Background' && x.title !== 'Mobile Background');
    setImgList(newImages);
  },[images]);
  return (
    <BackgroundImage
      Tag={`section`}
      id={`backgroundImage`}
      fluid={sources}
    >
      <Container className='pt-5'>
        <Row className={clsx(`d-flex flex-column align-items-center`, {
            'flex-md-row-reverse': imagePosition === 'Left',
            'flex-md-row': imagePosition === 'Right',
            'flex-column-reverse': imagePositionTop
          })}>
          {(text || buttons) &&
            <div className={clsx('col', {
                'text-center': !images || imagePosition === 'Center',
                'col-lg-10': imagePosition === 'Center'
              })}>
              {(showTitle && title) &&
                <SmallTitle>{title}</SmallTitle>
              }
              {text &&
                <RichText
                  json={text}
                  h1={'mb-3'}
                  h2={'h3 mb-3'}
                  p={'mb-3'}
                  ul={listClass}
                  li={'py-2'}
                />
              }
              {buttons && 
                <div className={clsx('d-flex flex-row mb-3', {'justify-content-center': !images || imagePosition === 'Center'})}>
                  {buttons.map(button => (
                    <Button
                      key={button.id}
                      to={button.link}
                      variant={button.variant}
                      size={button.size}
                      addClass={button.class}
                      copy={button.copy}
                      modal={button.modal}
                    />
                  ))}
                </div>
              }
            </div>
          }
          {imageList &&
            <div className={clsx('col', imageWidth, {
                'mb-3 mb-md-0': imagePositionTop
              })}>
              {imageList.map(image => (
                <Img
                  key={image.id}
                  loading='eager'
                  image={image.gatsbyImageData}
                  file={image.file}
                  alt={image.description}
                  style={{ maxHeight: imageMaxHeight }}
                  imgStyle={{ objectFit: imageMaxHeight ? 'contain' : ''}}
                />  
              ))}
            </div>
          }
        </Row>
      </Container>
    </BackgroundImage>
  )
}

export default BackgroundImages
